/* eslint-disable */
import axios from 'axios';


const axiosCall = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
})

export default axiosCall;